import {MediaQueryContext} from '@unthinkable/react-theme';
import {useContext} from 'react';

export const useMediaQuery = () => {
  return useContext(MediaQueryContext);
};
